import Swal from "sweetalert2";
import moment from "moment";
import { useMutation, useQueryClient } from "react-query";
import { useTranslation } from "react-i18next";
import { deleteInstallation } from "../../../../../services/treeCrud";

import { EditIcon, TrashIcon } from "@components/icons";

export default function InstallationMessage({
  tree,
  setIsUpdate,
  setOpenForm,
  setInstallationItem,
  setFieldValue,
  currentInstallations,
}) {
  return (
    <ul className="p-3">
      <MessageHeader />
      {tree?.installations
        ?.sort((a, b) => (a.date > b.date ? 1 : -1))
        ?.map((installation) => {
          return (
            <MessageItem
              installation={installation}
              key={installation.id}
              setIsUpdate={setIsUpdate}
              setOpenForm={setOpenForm}
              setInstallationItem={setInstallationItem}
              tid={tree.id}
              setFieldValue={setFieldValue}
              currentInstallations={currentInstallations}
            />
          );
        })}
    </ul>
  );
}

const MessageItem = ({
  installation,
  setIsUpdate,
  setOpenForm,
  setInstallationItem,
  tid,
  setFieldValue,
  currentInstallations,
}) => {
  // const { t } = useTranslation();
  const queryClient = useQueryClient();

  // Use tree ID from installation object as primary, tid prop as fallback
  const treeId = installation.tree?.id || tid;

  const installedDate = new Date(installation.installed_at);
  const removedDate = new Date(installation.removed_at);
  const readableInstalled = moment(installedDate).format("DD.MM.YYYY");
  const readableRemoved = moment(removedDate).format("DD.MM.YYYY");
  const { mutateAsync: installationDelete } = useMutation(deleteInstallation, {
    onSuccess: (data) => {
      console.log("Installation delete response:", data);
      console.log("Deleting installation ID:", installation.id, "from tree:", treeId);
      console.log("Installation sensor before delete:", installation.sensor);

      // Update form values directly for immediate UI update
      if (setFieldValue && currentInstallations) {
        const updatedInstallations = currentInstallations.filter(
          (inst) => inst.id !== installation.id
        );
        setFieldValue("installations", updatedInstallations);
      }

      // Update project cache to reflect installation deletion in tree_set
      console.log("Updating project cache for installation deletion...");
      const projectQueries = queryClient.getQueriesData({
        predicate: (query) => query.queryKey[0] === "project",
      });
      console.log("Found project queries to update:", projectQueries.length);
      projectQueries.forEach(([queryKey, projectData]) => {
        if (projectData) {
          queryClient.setQueryData(queryKey, (oldProject) => {
            if (!oldProject) return oldProject;

            return {
              ...oldProject,
              areas:
                oldProject.areas?.map((area) => ({
                  ...area,
                  tree_set:
                    area.tree_set?.map((tree) => {
                      if (tree.id === treeId) {
                        console.log(
                          "Removing installation",
                          installation.id,
                          "from tree",
                          tree.id,
                          "in project cache"
                        );
                        return {
                          ...tree,
                          installations:
                            tree.installations?.filter((inst) => inst.id !== installation.id) || [],
                        };
                      }
                      return tree;
                    }) || [],
                })) || [],
            };
          });
        }
      });

      // Still invalidate queries for other components
      const treeIdStr = treeId.toString();
      const treeIdNum = parseInt(treeId);
      queryClient.invalidateQueries(["tree", treeIdStr]);
      queryClient.invalidateQueries(["tree", treeIdNum]);
      queryClient.invalidateQueries("tree");
      queryClient.invalidateQueries("trees");
      queryClient.invalidateQueries("project");
      queryClient.invalidateQueries("possibleChildTrees");
      queryClient.invalidateQueries("possibleParentTrees");
    },
  });
  const handleDelete = (id) => {
    Swal.fire({
      html:
        '<p className="text-center"> ' +
        "Are you sure you want to delete " +
        // ` <b>${project.name} </b>` +
        "?" +
        "</p>",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#286CA5",
      cancelButtonColor: "#EF3600",
      cancelButtonText: "Cancel",
      confirmButtonText: "Delete",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire("Deleted!", "Your file has been deleted.", "success");
        installationDelete(id);
      }
    });
  };
  console.log("InstallationMessage rendering installation:", installation);
  console.log("Installation sensor data:", installation.sensor);
  console.log("Installation sensor name available:", !!installation.sensor?.name);

  return (
    <li className="d-flex gap-2 py-2 mb-3">
      <div style={{ width: "200px", fontWeight: "bold" }}>
        {installation.sensor?.name || `Sensor ${installation.sensor?.id}`}
      </div>
      <div className="w-100">
        <div className="d-flex align-items-center justify-content-between ">
          <p className="mb-0" style={{ fontSize: "12px" }}>
            {readableInstalled}
          </p>
          <p className="mb-0" style={{ fontSize: "12px" }}>
            {readableRemoved}
          </p>
          <span title="Edit">
            <EditIcon
              onClick={() => {
                setIsUpdate(true);
                setOpenForm(true);
                setInstallationItem(installation);
              }}
            />
            <TrashIcon
              onClick={() => {
                console.log("INSTA", installation);
                handleDelete(installation.id);
              }}
            />
          </span>
        </div>
        {/* <div className="pt-2"> */}
        {/*   <div className="mb-1"> */}
        {/*     {t("maintainance")}:{" "} */}
        {/*     {maintenance.tasks?.map((item, i) => ( */}
        {/*       <MaintenanceList taskItem={item} key={i} maintenance={maintenance} /> */}
        {/*     ))} */}
        {/*   </div> */}
        {/*   {maintenance.other && ( */}
        {/*     <div className="mb-1"> */}
        {/*       {t("other")}: {maintenance.other} */}
        {/*     </div> */}
        {/*   )} */}
        {/*   <div> */}
        {/*     <span> */}
        {/*       {t("time")}: <b> {maintenance.duration} hrs</b> */}
        {/*     </span> */}
        {/*   </div> */}
        {/*   <i>{maintenance.notes}</i> */}
        {/* </div> */}
      </div>
    </li>
  );
};

const MessageHeader = () => {
  const { t } = useTranslation();
  return (
    <li className="d-flex gap-2 py-2 mb-3">
      <div style={{ width: "200px", fontWeight: "bold" }}>{t("name")}</div>
      <div className="w-100">
        <div className="d-flex align-items-center justify-content-between ">
          <p className="mb-0" style={{ fontSize: "14.5px" }}>
            {t("installed_at")}
          </p>
          <p className="mb-0" style={{ fontSize: "14.5px" }}>
            {t("removed_at")}
          </p>
          <p className="mb-0" style={{ fontSize: "14.5px" }}>
            {t("actions")}
          </p>
        </div>
        {/* <div className="pt-2"> */}
        {/*   <div className="mb-1"> */}
        {/*     {t("maintainance")}:{" "} */}
        {/*     {maintenance.tasks?.map((item, i) => ( */}
        {/*       <MaintenanceList taskItem={item} key={i} maintenance={maintenance} /> */}
        {/*     ))} */}
        {/*   </div> */}
        {/*   {maintenance.other && ( */}
        {/*     <div className="mb-1"> */}
        {/*       {t("other")}: {maintenance.other} */}
        {/*     </div> */}
        {/*   )} */}
        {/*   <div> */}
        {/*     <span> */}
        {/*       {t("time")}: <b> {maintenance.duration} hrs</b> */}
        {/*     </span> */}
        {/*   </div> */}
        {/*   <i>{maintenance.notes}</i> */}
        {/* </div> */}
      </div>
    </li>
  );
};
